/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4CrossDiagIcon16Light = forwardRef('ArrowDim4CrossDiagIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.5 6.5A.5.5 0 0 0 14 6V3a1 1 0 0 0-1-1h-3a.5.5 0 0 0 0 1h2.293L8 7.293 3.707 3H6a.5.5 0 0 0 0-1H3a1 1 0 0 0-1 1v3a.5.5 0 0 0 1 0V3.707L7.293 8 3 12.293V10a.5.5 0 0 0-1 0v3a1 1 0 0 0 1 1h3a.5.5 0 0 0 0-1H3.707L8 8.707 12.293 13H10a.5.5 0 0 0 0 1h3a1 1 0 0 0 1-1v-3a.5.5 0 0 0-1 0v2.293L8.707 8 13 3.707V6a.5.5 0 0 0 .5.5Z" })));
});
